<template>
    <div class="history-management-view">
        <div class="documentmanagement-header">
            <div class="header-section flex gap-10" :class="{'has-breadcrumbs': currentSectionId}">
                
                <text class="first-el">
                    <router-link v-if="currentSectionId" to="/tasks/" class="main-item">
                        Tasks 
                    </router-link>
                    <text v-else>
                        Tasks 
                    </text>
                </text>
                <img v-if="currentSectionId" src="@/assets/arrow-opener.svg" alt="arrow-right"  class="p-10" />
                <div v-if="currentSectionId" class="first-el">
                    <router-link v-if="currentSectionId" :to="linkToWorkFlow" class="main-item">
                        {{ sectionName }} 
                    </router-link>
                </div>
            </div>


        </div>

        <div class="task-list flex gap-4 wrap" >
            <div v-for="task in tasks" :key="task.id" class="task-item pointer" @click="openTask(task)">
                <div class='preview-content' v-html="task.firstComment.message"></div>
                <p>{{ task.description }}</p>

                <p v-if="!id">
                    <b>Client:</b> 
                    {{ task.company_data[0]?.name || (task.company_data[0]?.first_name + ' ' + task.company_data[0]?.last_name) }}
                </p>
                <p><b>Status:</b> {{ task.task_status.toUpperCase() }}</p>
                <p><b>submitted:</b> 
                    {{ dayjs(task.createdAt, 'YYYY-MM-DD HH:MM').format('DD/MM/YYYY HH:MM') }}
                </p>
                
                <div class="task-line flex gap-4 align-center">
                    <p class="bold">Creator:</p>
                    <p class="limit-length">{{ task.creator_.username }}</p>
                    <div class="user-label">
                        <strong>
                            <span>
                                {{ userLabel(task.creator_) }}
                            </span>
                        </strong>
                    </div>
                </div>

                <div class="task-line flex gap-4 align-center">
                    <p class="bold">Executor:</p>
                    <p class="limit-length">{{ task.assignee_?.username || 'N/A' }}</p>
                    <div class="user-label" v-if="task.assignee_?.username">
                        <strong>
                            <span>
                                {{ userLabel(task.assignee_) }}
                            </span>
                        </strong>
                    </div>
                </div>
                
            </div>
            <div v-if="!tasks.length && loaded">
                <p>No Tasks for this client</p>
            </div>
                
        </div>
    </div>
</template>

<script setup>

    import { ref, computed, onMounted, watch } from 'vue';
    import API from '@/api';
    import dayjs from 'dayjs'

    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';

    const router = useRouter();
    const store = useStore();
    const loaded = ref(false);
    const props = defineProps(['id', 'task_id']);
    const tasks = ref([]);
    const taskMessages = ref(null)
    const signleTask = ref(null);
    const companyData = computed(() => store.state.companyData);
    function openTask(task) {
        router.push({
            name: 'task-view',
            params: {
                task_id: task._id,
                id: task.company_data[0]?._id,
            }
        });
    }
    const linkToWorkFlow = computed( () => ({name: 'client-item', params: {id: currentSectionId.value}}) )

    const sectionName = computed(() => {
        if (!companyData.value) {
            return 'N/A';
        }
        if (companyData.value.company_type == 'corporate') {
            return companyData.value.name.value + ' Corporate';
        } 
        return companyData.value.first_name.value + " " + companyData.value.last_name.value + ' Account Holder';
    })
    const currentSectionId = ref(null);
    async function loadData(){
        loaded.value = false;
        currentSectionId.value = props.id;
        const response = await API.getTasks(props.id);

        if (!companyData.value && props.id) {
            await API.loadDashboardData({company_id: props.id});
            store.dispatch('loadEnv', { id: props.id } );
        }
        if (props.task_id) {
            const response = await API.getTask(props.task_id);
            signleTask.value = response.task;
            taskMessages.value = response.messages;
        }
        tasks.value = response.tasks;
        loaded.value = true;

    }
    onMounted( async () => {
       await loadData();
    });

    function userLabel(user){
        if (user.first_name && user.last_name) {
            return `${user.first_name[0]}${user.last_name[0]}`
        } else {
            return user.username[0] + user.username[1]
        }
    }
    watch( () => props.task_id, async (newValue) => {
        if (newValue) {
            const response = await API.getTask(newValue);
            signleTask.value = response.task;
            taskMessages.value = response.messages;
        }
    });
    watch(() => props.id, (newVal) => {
        currentSectionId.value = newVal;
        if (newVal) {
            loaded.value = false;
            loadData();
        } else {
            // store.dispatch('setValue', { key: 'companyData', value: null });
            store.dispatch('setValue', { key: 'notificationsCount', value: null })
        }
    })

</script>


<style lang="scss" scoped>

    .documentmanagement-header {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 20px;
        text-align: left;
        color: black;
        padding-top: 20px;
    }
    .history-management-view {
        display: flex;
        padding: 20px;
        flex-direction: column;
        max-width: 1350px;
        margin: auto;
    }
    .task-item {

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        background-color: #f9f9f9;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        border: 1px solid var(--border-color);
        width: 300px;
        height: 250px;
        
        p {
            margin: 0;
            font-size: 16px;
            color: #333;
        }
    }
    .user-label {
        background-color: rgb(236 240 255);
        border-radius: 50%;
        width: 45px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--primary-color);
    }
    .preview-content {
        width: 250px;
        height: 100px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 5; /* Approximate number of lines to show */
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        font-weight: bold;
        font-size: 14px;
        &:deep(*) {
            margin: 0;
            text-align: left;
        }
        &:deep(p) {
            display: inline;
        }
    }
    .limit-length {
        max-width: 155px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .has-breadcrumbs {
        display: flex;
        align-items: center;
        font-size: 16px;
        .first-el > a {
            font-size: 16px;
            color: var(--primary-color);
            text-decoration: none;
        }
    }
    .header-section[class] {
        padding-top: 0;
    }
</style>